import { apiFetch } from './apiClient';
import {
  AssignAddOnsRequest,
  AssignTierRequest,
  SubscriptionPricingDto,
  UserSubscriptionDetailsDto,
  AddOnDto,
  CreateAddOnDto,
  CreateTierDto,
  TierAddOnDto,
  TierDto,
  UpdateAddOnDto,
  UpdateTierDto,
} from '../types/userManagement';

const USER_BASE_PATH = '/api/v1/admin/users';
const SUBSCRIPTION_BASE_PATH = '/api/v1/admin/subscriptions';

export const subscriptionApi = {
  getUserSubscription: (userId: string) =>
    apiFetch<UserSubscriptionDetailsDto>(`${USER_BASE_PATH}/${userId}/subscription`),
  getUserSubscriptionPricing: (userId: string) =>
    apiFetch<SubscriptionPricingDto>(`${USER_BASE_PATH}/${userId}/subscription/pricing`),
  updateUserSubscriptionTier: (userId: string, request: AssignTierRequest) =>
    apiFetch<void>(`${USER_BASE_PATH}/${userId}/subscription/tier`, {
      method: 'PUT',
      body: JSON.stringify(request),
    }),
  assignUserAddOns: (userId: string, request: AssignAddOnsRequest) =>
    apiFetch<void>(`${USER_BASE_PATH}/${userId}/subscription/addons`, {
      method: 'POST',
      body: JSON.stringify(request),
    }),
  removeUserAddOn: (userId: string, addOnId: number) =>
    apiFetch<void>(`${USER_BASE_PATH}/${userId}/subscription/addons/${addOnId}`, {
      method: 'DELETE',
    }),
  getTiers: () => apiFetch<TierDto[]>(`${SUBSCRIPTION_BASE_PATH}/tiers`),
  getTier: (tierId: number) => apiFetch<TierDto>(`${SUBSCRIPTION_BASE_PATH}/tiers/${tierId}`),
  createTier: (request: CreateTierDto) =>
    apiFetch<TierDto>(`${SUBSCRIPTION_BASE_PATH}/tiers`, {
      method: 'POST',
      body: JSON.stringify(request),
    }),
  updateTier: (tierId: number, request: UpdateTierDto) =>
    apiFetch<TierDto>(`${SUBSCRIPTION_BASE_PATH}/tiers/${tierId}`, {
      method: 'PUT',
      body: JSON.stringify(request),
    }),
  deleteTier: (tierId: number) =>
    apiFetch<void>(`${SUBSCRIPTION_BASE_PATH}/tiers/${tierId}`, { method: 'DELETE' }),
  getAddOns: () => apiFetch<AddOnDto[]>(`${SUBSCRIPTION_BASE_PATH}/addons`),
  getAddOn: (addOnId: number) => apiFetch<AddOnDto>(`${SUBSCRIPTION_BASE_PATH}/addons/${addOnId}`),
  createAddOn: (request: CreateAddOnDto) =>
    apiFetch<AddOnDto>(`${SUBSCRIPTION_BASE_PATH}/addons`, {
      method: 'POST',
      body: JSON.stringify(request),
    }),
  updateAddOn: (addOnId: number, request: UpdateAddOnDto) =>
    apiFetch<AddOnDto>(`${SUBSCRIPTION_BASE_PATH}/addons/${addOnId}`, {
      method: 'PUT',
      body: JSON.stringify(request),
    }),
  deleteAddOn: (addOnId: number) =>
    apiFetch<void>(`${SUBSCRIPTION_BASE_PATH}/addons/${addOnId}`, { method: 'DELETE' }),
  getTierAddOns: (tierId: number) =>
    apiFetch<TierAddOnDto[]>(`${SUBSCRIPTION_BASE_PATH}/tiers/${tierId}/addons`),
  assignTierAddOn: (tierId: number, request: TierAddOnDto) =>
    apiFetch<void>(`${SUBSCRIPTION_BASE_PATH}/tiers/${tierId}/addons`, {
      method: 'POST',
      body: JSON.stringify(request),
    }),
  removeTierAddOn: (tierId: number, addOnId: number) =>
    apiFetch<void>(`${SUBSCRIPTION_BASE_PATH}/tiers/${tierId}/addons/${addOnId}`, {
      method: 'DELETE',
    }),
};